/**
 * Default function to get text length.
 *
 * @param {string} value
 * @returns {number}
 */
export function getTextLength(value) {
  return (value && value.length) || 0
}

export function isSymbolCounterLimitReached({ currentLength, maxLength }) {
  return Boolean(maxLength) && currentLength >= maxLength
}
